export default "__VITE_PUBLIC_ASSET__2173c8f1__"